module.exports = __webpack_public_path__ + "assets/img/chronicleImg-646e2b66.png";